<template>
  <div id="results">
    <div v-if="$root.fittings.length">
      <p>
        Below are products recommended just for you!
      </p>

      <div class="ff-logo">
        <div>
          Powered by
        </div>
        <img src="../img/ff-logo.svg">
      </div>

      <template>
        <result
          v-for="product in $root.fittings"
          :key="product.shopify_id"
          :product="product"
        />
      </template>
    </div>
    <p v-if="$root.fittings && !$root.fittings.length">
      No products match your search. We recommend ordering your typical swimsuit size.
    </p>
    <p v-if="!$root.fittings">
      Loading...
    </p>
  </div>
</template>

<script>
  import result from "./result.vue";

  export default {
    components: {
      result,
    },
  }
</script>

<style lang="less" scoped>
.laya-swim-fitting {
  #results {
    vertical-align: top;
    margin-top: 55px;
  }
  .confidence-container {
    max-width: 1024px;
    margin: 0 auto;
    text-align: left;
  }
  .confidence-table {
    display: inline-block;
    padding: 5px 8px;
    text-align: left;
    border: 1px solid grey;
  }
  .flex {
    display: flex;
  }
  .ff-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    span {
      line-height: 0px;
    }

    img {
      margin: 0 !important;
      margin-left: 5px !important;
      height: 27px;
    }
  }
}
</style>
